import React from 'react';
import { Route } from 'react-router-dom';

import SESFicha from '../../SES/SES/SESFicha';
import SESIndex from '../../SES/SES/SESIndex';
import SESUsuarios from '../../SES/UsuarioSES';
import SESVinculo from '../../SES/Vinculo';

const SESRoutes = () => {
  return (
    <>
      {/* SES */}
      <Route path="ses/ses" element={<SESIndex />} />
      <Route path="ses/ses/ficha/dadosgerais" element={<SESFicha />} />
      <Route path="ses/ses/ficha/:id/dadosgerais" element={<SESFicha />} />
      <Route path="ses/ses/ficha/usuarios" element={<SESUsuarios />} />
      <Route path="ses/ses/ficha/:id/usuarios" element={<SESUsuarios />} />
      <Route path="ses/ses/ficha/vinculo" element={<SESVinculo />} />
      <Route path="ses/ses/ficha/:id/vinculo" element={<SESVinculo />} />
    </>
  );
};

export default SESRoutes;
